<template>
  <div class="">
    <h1>用户管理</h1>
    
  </div>
</template>

<script>
export default {
  name: '',
  data () {
    return {
      msg: ''
    }
  }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/system/userManage.vue